/* =============================================================================
   Freedom Sale — countdown ticker
   -----------------------------------------------------------------------------
   Drives every [data-fs-ends] element on the page (announcement bar, PDP strip,
   homepage banner). Each element carries the sale end time as epoch SECONDS,
   computed in Liquid from the "Sale ends" theme setting — so the browser's own
   timezone never enters the maths, only the difference between two epochs.

   When the sale has expired the element hides itself. That is a cosmetic
   backstop only: snippets/freedom-sale-active.liquid already stops the server
   from rendering any sale surface past the end time, and the real discount is
   the Automatic Discount in Admin. This file never promises anything on its own.

   Loaded by several surfaces on the same page; the flag below keeps one ticker.
   ============================================================================= */
(function () {
  if (window.__fsCountdownBound) { return; }
  window.__fsCountdownBound = true;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* "2d 04h 11m" while more than an hour is left, then "04h 11m 09s" so the last
     hour visibly moves. Days are dropped once there are none rather than showing
     a dead "0d". */
  function label(secs) {
    var d = Math.floor(secs / 86400);
    var h = Math.floor((secs % 86400) / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    if (d > 0) { return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm'; }
    if (h > 0) { return pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's'; }
    return pad(m) + 'm ' + pad(s) + 's';
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-fs-ends]');
    if (!nodes.length) { return; }
    var now = Math.floor(Date.now() / 1000);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var end = parseInt(el.getAttribute('data-fs-ends'), 10) || 0;
      var left = end - now;
      if (!end || left <= 0) {
        el.hidden = true;
        continue;
      }
      var out = el.querySelector('[data-fs-clock]') || el;
      var text = label(left);
      if (out.textContent !== text) { out.textContent = text; }
    }
  }

  tick();
  setInterval(tick, 1000);
})();
